import { render, staticRenderFns } from "./search-results-wrapper.vue?vue&type=template&id=bf2cdd52&"
import script from "./search-results-wrapper.vue?vue&type=script&lang=js&"
export * from "./search-results-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports